import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.435 5.434a.8.8 0 0 1 1.13 0l6 6a.8.8 0 0 1 0 1.132l-6 6a.8.8 0 0 1-1.13-1.132L13.869 12 8.435 6.566a.8.8 0 0 1 0-1.132",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }